export default "__VITE_ASSET__CI08YJuO__"